import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import { cpf } from '~/prix/types/mask'
import { latitude, longitude } from '~/prix/types/presets/geo'
import sql from '~/prix/utils/sql'

export const citizenObject = z.object({
  id: z.string().uuid(),
  residencesId: z.array(z.string().uuid()).nullish(),
  fullName: z.string(),
  nickname: z.string().nullish(),
  socialName: z.string().nullish(),
  sex: enumerated({
    male: 'Masculino',
    female: 'Feminino',
  }).describe('Sexo biológico'),
  cpf: cpf().or(z.literal('')).nullish(),
  cns: z.string().nullish(),
  isResponsible: z
    .union([z.boolean(), z.literal(1), z.literal(0)])
    .transform(val => !!val)
    .describe('É responsável familiar'),
  whatsapp: z.string().nullish(),
  alternatePhone: z.string().nullish(),
  fullAddress: z.string().nullish(),
  complement: z.string().nullish(),
  latitude: latitude().nullish(),
  longitude: longitude().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  observation: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
})

export const propertyMap = {
  id: sql`id`,
  residencesId: sql`residences_id`,
  fullName: sql`full_name`,
  nickname: sql`nickname`,
  socialName: sql`social_name`,
  sex: sql`sex`,
  cpf: sql`cpf`,
  cns: sql`cns`,
  isResponsible: sql`is_responsible`,
  whatsapp: sql`whatsapp`,
  alternatePhone: sql`alternate_phone`,
  fullAddress: sql`full_address`,
  complement: sql`complement`,
  latitude: sql`latitude`,
  longitude: sql`longitude`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  observation: sql`observation`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  synchronizedAt: sql`synchronized_at`,
  deletedAt: sql`deleted_at`,
  sourceFilter: sql`source_filter`,
}

export type CitizenType = z.infer<typeof citizenObject>
